/** @jsxImportSource @emotion/react */
import React from "react";
import { ReactComponent as CancelIcon } from "../../../../img/approval_svgs/Cancel.svg";
import { css } from "@emotion/react";
import { verticalAlignedFlexbox } from "../../../../config/commonCSS";

export const TryAgain: React.FC<{ onClick: () => void; isVisible: boolean }> = ({
  onClick,
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div css={verticalAlignedFlexbox}>
      <CancelIcon />
      <span
        className="text-error"
        css={css`
          margin-right: 24px;
          font-weight: 400;
          font-size: 14px;
          line-height: 130%;
        `}
      >
        Rejected
      </span>
      <button className="approve-btn" onClick={onClick}>
        Try Again
      </button>
    </div>
  );
};
